import { Textarea } from '@acpaas-ui/react-components';
import { useState } from 'react';
import Modal from '../Modal';
import ModalTitle from '../ModalTitle';

const ClarificationApproveModal = ({ isOpen, onClose, onConfirm }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [remark, setRemark] = useState('');

  const handleClose = () => {
    setIsSubmitting(false);
    setError('');
    onClose();
  };

  const onApproveError = (error) => {
    setError(error);
    setIsSubmitting(false);
  };

  const onApproveSuccess = () => {
    setError('');
    setIsSubmitting(true);
    handleClose();
  };

  const handleConfirm = () => {
    setError('');
    setIsSubmitting(true);
    onConfirm(remark, onApproveError, onApproveSuccess);
  };

  return (
    <Modal
      title={
        <ModalTitle
          title="Goedkeuren"
          subtitle="Wanneer je deze vraagverheldering goedkeurt zal het dossier naar de volgende fase gaan en krijgen de betrokken
      personen hiervan een notificatie."
        />
      }
      isOpen={isOpen}
      isSubmitting={isSubmitting}
      onClose={handleClose}
      onConfirm={handleConfirm}
      onConfirmLabel="Goedkeuren"
      onConfirmIcon="ai-check-1"
      onConfirmType="success"
    >
      <Textarea
        label="Wil je nog extra opmerkingen meegeven?"
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
      />
      {error && <small className="u-block u-margin-top-sm u-text-danger">{error}</small>}
    </Modal>
  );
};

export default ClarificationApproveModal;
